'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withColorsPropTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./with-color.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var semanticColors = ['primary', 'secondary', 'positive', 'success', 'warning', 'error', 'presentational', 'info', 'instruction'];

var colorOptions = ['white', 'lightest', 'lighter', 'light', 'dark', 'darker', 'darkest', 'mint'];

var withColorsPropTypes = exports.withColorsPropTypes = {
  color: _propTypes2.default.oneOf([].concat(colorOptions, semanticColors))
};

function withColor(Component) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var WithColor = function WithColor(_ref) {
    var className = _ref.className,
        _ref$color = _ref.color,
        color = _ref$color === undefined ? defaults.color : _ref$color,
        props = _objectWithoutProperties(_ref, ['className', 'color']);

    var classes = (0, _classnames2.default)('with-color', color && 'with-color--color-' + color, className);

    return _react2.default.createElement(Component, _extends({ className: classes }, props));
  };

  WithColor.propTypes = _extends({}, Component.propTypes, withColorsPropTypes);

  return WithColor;
}

exports.default = withColor;